import { render, staticRenderFns } from "./SearchCategories.vue?vue&type=template&id=78b19e9a"
import script from "./SearchCategories.vue?vue&type=script&lang=js"
export * from "./SearchCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports